import { render, staticRenderFns } from "./VisitContactRedirect.vue?vue&type=template&id=c721a2e4&scoped=true"
import script from "./VisitContactRedirect.vue?vue&type=script&lang=js"
export * from "./VisitContactRedirect.vue?vue&type=script&lang=js"
import style0 from "./VisitContactRedirect.vue?vue&type=style&index=0&id=c721a2e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c721a2e4",
  null
  
)

export default component.exports